import FilePickerUploadConfiguration from '../store/schema/FilePickerUploadConfiguration';
import { action } from 'satcheljs/lib/legacy';
import { getFilePickerStore } from '../store/filePickerStore';

export default action('setCustomUploadConfiguration')(function(
    uploadConfiguration: FilePickerUploadConfiguration
): void {
    getFilePickerStore().viewState.filePickerActionsViewState.uploadConfiguration = uploadConfiguration;
});
